module.exports = __webpack_public_path__ + "img/loginMongolia_banner.1116b2fa.png";